import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { emptyArray, emptyObject } from 'ui-components/default-props/empty';
import { BulkActions } from '../../../../enums/bulk-actions';
import { getAllNoteTypes } from '../../../../services/order-note-service';
import { SimpleDropdown } from '../../../../components/simple-dropdown';
import { messages } from '../messages';

import style from './add-note.module.less';
import { BulkUpdateNoteTypePropType } from '../../../../prop-types/bulk-update-note-type';

export const NoteDropdownAndField = ({ model, onChange, customFieldTypeOption }) => {
  const note = model.note ?? emptyObject;
  const { noteType, body } = note;
  const noteTypeOptions = customFieldTypeOption ? emptyArray : getAllNoteTypes();
  const matchingNoteTypeOption = customFieldTypeOption ?? noteTypeOptions.find((option) => option.id === noteType);
  const mappedNoteTypeOptions = customFieldTypeOption
    ? emptyArray
    : noteTypeOptions.map((option) => ({
        name: option.message,
        key: option.id,
      }));

  const onNoteTypeChange = useCallback(
    (newNoteType) =>
      onChange({
        ...model,
        note: {
          ...note,
          noteType: newNoteType,
        },
      }),
    [model, note, onChange],
  );

  const onNoteBodyChange = useCallback(
    (event) =>
      onChange({
        ...model,
        note: {
          ...note,
          body: event.target.value,
        },
      }),
    [model, note, onChange],
  );

  return (
    <div className={style['add-note']}>
      {!customFieldTypeOption && (
        <SimpleDropdown
          defaultTitle={<FormattedMessage {...messages.pleaseSelect} />}
          dropdownMenuShouldHaveWidthOfButton
          items={mappedNoteTypeOptions}
          label={<FormattedMessage {...messages.noteType} />}
          onItemSelected={onNoteTypeChange}
          selectedItemKey={matchingNoteTypeOption?.id}
        />
      )}
      {matchingNoteTypeOption && (
        <>
          <textarea className={style['note-body-textarea']} onChange={onNoteBodyChange} value={body} />
          <div className={style['note-type-message']}>
            <FormattedMessage {...messages.addNoteMessage} values={{ noteType: matchingNoteTypeOption.message }} />
          </div>
        </>
      )}
    </div>
  );
};

NoteDropdownAndField.propTypes = {
  customFieldTypeOption: BulkUpdateNoteTypePropType,
  model: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export const AddNote = {
  id: BulkActions.addNote.name,
  render: (onChange, model) => <NoteDropdownAndField model={model} onChange={onChange} />,
};
